<template>
    <el-dialog title="会员积分详情" style="text-align:center" :visible="visible" :show="show" width="50%"
               :close-on-click-modal="false"
               @close="close">
            <el-table :data="tableData" style="height:400px;width:100%" stripe :loadding="dataListLoading">
                <el-table-column type="index" label="序号" align="center"></el-table-column>
                <el-table-column prop="points" label="积分" align="center"></el-table-column>
                <el-table-column prop="createTime" label="发生时间" align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.createTime)}}
                    </template>
                </el-table-column>
                <el-table-column prop="context" label="描述" width="400" header-align="center"></el-table-column>
            </el-table>
    </el-dialog>
</template>
<script>
    export default{
        name:'userPointsDetail',
        data() {
            return {
                tableData:[],
                visible:false,
                dataListLoading:false,
            };
        },
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
            },
            rowData(){
                this.loaddingPointsDetail(this.rowData.id);
            },
        },
        methods:{
            close(){
                this.tableData = [];
                this.$emit("listenToChildEvent",false);
            },
            loaddingPointsDetail(id){
                this.dataListLoading = true;
                this.$http({
                    url: "userPoints/info/"+id,
                    method: "get",
                }).then(({data}) => {
                    this.tableData = data.detailList;
                    this.dataListLoading = false;
                });
            },
            formatDate(dateStr){
                let date = new Date(dateStr);
                return date.toLocaleString();
            },
        }

    }
</script>